import { Injectable } from '@angular/core';
import { TranslateDefaultParser } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class CustomTranslateParser extends TranslateDefaultParser {
  public interpolate(expr: string, params?: any): string {
    const value: string = super.interpolate(expr, params);
    return value;
  }
  public getValue(target: any, key: string): string {
    let value: string = super.getValue(target, key);
    // check if translate value is key
    if (value && value.toString().charAt(0) === '{' && value.toString().endsWith('}') &&
      ((value.match(/{{/g) || []).length === 1 && (value.match(/}}/g) || []).length === 1)) {
      value = this.getValueIfValueIsKey(target, value.toString());
    }
    return value;
  }

  private getValueIfValueIsKey(target: any, value: string): string {
    let result: string = value;
    value = value.slice(1);
    if (parseFloat(value.split('}')[0])) {
      return result;
    }
    value = value.slice(0, value.length - 1);
    if (value && value.charAt(0) === '{' && value.endsWith('}')) {
      value = value.slice(1);
      if (parseFloat(value.split('}')[0])) {
        return result;
      }
      value = value.slice(0, value.length - 1);
      result = this.getValue(target, value);
    }
    return result;
  }
}
